import React, { useState, useRef, useEffect } from "react";
import { Dimmer } from "../spinner";
import moment from "moment";
import axios from "axios";
import {
  formatMoneda,
  validaSoloNumero,
  validaMonto,
  formatoMonto,
  validaNumeroTelefono,
} from "../../util/varios";
import CatalogoTimbres from "../../catalogos/catalogoTimbres";
import CatalogoAgenteTipo from "../../catalogos/catalogoAgenteTipo";
import { Mensaje } from "../mensajes";
import { CambioTimbre } from "./timbrecambio";

function AnularTimbres() {
  /////#####Declaracion de variables#####/////

  /////variables nativas js
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const op = require("../../../public/modulos/datos");

  /////variables de referencias
  const txtIdPlanilla = useRef();
  const txtIdTimbre = useRef();
  const txtidexpendio = useRef();
  const txtfechaasignado = useRef();
  const txtestatustimbre = useRef();
  const txtusuariohabilitado = useRef();
  const txtusuarioinhabilitado = useRef();
  const txtmotivodesincorporacion = useRef();
  const txtfechadesincorporado = useRef();
  const txtut = useRef();
  const txtfechahabilitado = useRef();
  const txtfechainhabilitado = useRef();
  const txtfechagenerado = useRef();
  const txtvalorut_asignacion = useRef();
  const txtvalorut_venta = useRef();
  const txtenterado = useRef();
  const txtfecha_enterado = useRef();
  const txtidfactura = useRef();
  const txtusuariodesincorporado = useRef();
  const txtusuariogenerado = useRef();
  const txtusuarioasignado = useRef();

  /////variables de estados
  const [valorute, setValorute] = useState(0.0);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [mostrar, setMostrar] = useState(false);
  const [mostrarcambio, setMostrarCambio] = useState(false);
  const [mostrarAgenteTipo, setMostrarAgenteTipo] = useState(false);
  const [inhabilitado, setInhabilitado] = useState(true);
  const [valorpetro, setValorpetro] = useState(0.0);
  const [visibleEnterado, setVisibleEnterado] = useState("collapse");
  const [tipo, setTipo] = useState(0);
  const [tipoU, setTipoU] = useState("");
  const [modificar, setModificar] = useState(false);
  const [border, setBorder] = useState(
    "form-select form-select-sm rounded-pill"
  );
  const [texto, setTexto] = useState(
    "input-group-text border-0 bg-transparent"
  );
  const [icono, setIcono] = useState(
    "mx-auto text-dark fas fa-8x fa-file-invoice"
  );
  const [values, setValues] = useState({
    idtimbredetalle: "",
    idplanillatimbre: "",
    idexpendio: "",
    fechaasignado: "",
    estatustimbre: "",
    usuariohabilitado: "",
    usuarioinhabilitado: "",
    motivodesincorporacion: "",
    fechadesincorporado: "",
    ut: "",
    fechahabilitado: "",
    fechainhabilitado: "",
    fechagenerado: "",
    valorut_asignacion: "",
    valorut_venta: "",
    enterado: "",
    fecha_enterado: "",
    idfactura: "",
    usuariodesincorporado: "",
    usuariogenerado: "",
    usuarioasignado: "",
  });
  /////#####$$$$$#####/////

  /////#####funcion para cambiar el estado de values#####/////
  const onChange = (event) => {
    if (
      event.target.name === "usuariogenerado" ||
      event.target.name === "usuarioasignado" ||
      event.target.name === "usuariohabilitado" ||
      event.target.name === "usuarioinhabilitado" ||
      event.target.name === "usuariodesincorporado" ||
      event.target.name === "idexpendio"
    ) {
      validaSoloNumero(event);
      if (event.which === 13 || typeof event.which === "undefined") {
      } else if (event.which === 46) {
        return false;
      } else if (event.which >= 48 && event.which <= 57) {
        event.target.value = event.target.value;
        return true;
      } else if (event.which === 8 || event.which === 0 || event.which === 44) {
        return true;
      } else return false;
      setValues({ ...values, [event.target.name]: event.target.value });
    } else if (event.target.name === "enterado") {
      if (event.target.checked) {
        setValues({ ...values, [event.target.name]: true });
        setVisibleEnterado("visible");
      } else {
        setValues({ ...values, [event.target.name]: false });
        setVisibleEnterado("collapse");
      }
    } else if (event.target.name === "estatustimbre") {
      setValues({ ...values, [event.target.name]: event.target.value });
      if (event.target.value === "1") {
        setValues({
          ...values,
          [event.target.name]: event.target.value,
          valorut_asignacion: valorute,
        });
      } else if (event.target.value === "2") {
        setValues({
          ...values,
          [event.target.name]: event.target.value,
          valorut_venta: valorute,
        });
      } else {
        setValues({ ...values, [event.target.name]: event.target.value });
      }
    } else {
      setValues({ ...values, [event.target.name]: event.target.value });
    }
  };
  /////#####$$$$$#####/////

  /////#####funcion para formatear el monto#####/////
  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth
        );
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };
  /////#####$$$$$#####/////

  /////#####funcion para blanquear campos#####/////
  const blanquear = () => {
    txtestatustimbre.current.value = "";
    setBorder("form-select form-select-sm rounded-pill");
    setTexto("input-group-text border-0 bg-transparent");
    setIcono("mx-auto text-dark fas fa-8x fa-file-invoice");
    setVisibleEnterado("collapse");
    setInhabilitado(true);
    setModificar(true);
    setValues({
      idtimbredetalle: "",
      idplanillatimbre: "",
      idexpendio: "",
      fechaasignado: "",
      estatustimbre: "",
      usuariohabilitado: "",
      usuarioinhabilitado: "",
      motivodesincorporacion: "",
      fechadesincorporado: "",
      ut: "",
      fechahabilitado: "",
      fechainhabilitado: "",
      fechagenerado: "",
      valorut_asignacion: "",
      valorut_venta: "",
      enterado: "",
      fecha_enterado: "",
      idfactura: "",
      usuariodesincorporado: "",
      usuariogenerado: "",
      usuarioasignado: "",
    });
  };
  /////#####$$$$$#####/////

  /////#####funcion para deshabilitar botones y blanquear#####/////
  const cancelar = () => {
    setInhabilitado(true);
    setModificar(true);
    blanquear();
  };
  /////#####$$$$$#####/////

  /////#####validar timbre#####/////
  const validarTimbre = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setModificar(false);
        seleccionarRegistro(event.target.value);
      } else {
        blanquear();
      }
    }
  };
  /////#####$$$$$#####/////

  /////#####consulta para obtener datos del timbre por el id#####/////
  const seleccionarRegistro = (id) => {
    let endpoint = `${op.conexion}/api/timbres/${id}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setValues(response.data);
          if (response.data.enterado) {
            setVisibleEnterado("visible");
          } else {
            setVisibleEnterado("collapse");
          }
          if (response.data.estatustimbre === 0) {
            setBorder(
              "form-select form-select-sm rounded-pill border border-info text-info text-center border-4"
            );
            setTexto("input-group-text border-0 bg-transparent text-info");
            setIcono("mx-auto text-info fas fa-8x fa-file-invoice");
            txtestatustimbre.current.value = response.data.estatustimbre;
          } else if (response.data.estatustimbre === 1) {
            setBorder(
              "form-select form-select-sm rounded-pill border border-secondary text-secondary text-center border-4"
            );
            setTexto("input-group-text border-0 bg-transparent text-secondary");
            setIcono("mx-auto text-secondary fas fa-8x fa-file-invoice");

            txtestatustimbre.current.value = response.data.estatustimbre;
          } else if (response.data.estatustimbre === 2) {
            setBorder(
              "form-select form-select-sm rounded-pill border border-primary text-primary text-center border-4"
            );
            setTexto("input-group-text border-0 bg-transparent text-primary");
            setIcono("mx-auto text-primary fas fa-8x fa-file-invoice");
            txtestatustimbre.current.value = response.data.estatustimbre;
          } else if (response.data.estatustimbre === 3) {
            setBorder(
              "form-select form-select-sm rounded-pill border border-warning text-warning text-center border-4"
            );
            setTexto("input-group-text border-0 bg-transparent text-warning");
            setIcono("mx-auto text-warning fas fa-8x fa-file-invoice");
            txtestatustimbre.current.value = response.data.estatustimbre;
          } else if (response.data.estatustimbre === 4) {
            setBorder(
              "form-select form-select-sm rounded-pill border border-danger text-danger text-center border-4"
            );
            setTexto("input-group-text border-0 bg-transparent text-danger");
            setIcono("mx-auto text-danger fas fa-8x fa-file-invoice");
            txtestatustimbre.current.value = response.data.estatustimbre;
          }
          setModificar(false);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };
  /////#####$$$$$#####/////

  /////#####consulta para obtener datos del timbre por el id#####/////
  const seleccionarvalorpetro = () => {
    let endpoint = `${op.conexion}/api/comun/valorpetro`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          console.log(response.data);
          if (response.data.valor !== null && response.data.valor !== "") {
            seleccionarporce(response.data.valor);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarporce = (petro) => {
    let endpoint = `${op.conexion}/api/porcentajeute/porce`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          console.log(response.data);
          if (response.data.valor !== null && response.data.valor !== "") {
            setValorute(petro * response.data.valor);
          }

          setValorpetro(response.data.valor);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };
  /////#####$$$$$#####/////

  /////#####funcion para abrir o cerrar el catalogo de los timbres#####/////
  const onhideCatalogo = () => {
    if (!mostrar) {
      setMostrar(true);
      blanquear();
    } else {
      setMostrar(false);
    }
  };
  /////#####$$$$$#####/////

  /////#####funcion para abrir o cerrar el catalogo de los Agente#####/////
  const showCatalogo = () => {
    if (!mostrarAgenteTipo) {
      setMostrarAgenteTipo(true);
    } else {
      setMostrarAgenteTipo(false);
    }
  };
  /////#####$$$$$#####/////

  /////#####funcion para abrir o cerrar el catalogo de los Agente#####/////
  const seleccionarUsuario = (t, u) => (e) => {
    e.preventDefault();
    setTipo(t);
    setTipoU(u);
    showCatalogo();
  };
  /////#####$$$$$#####/////

  /////#####funcion para seleccionar el timbre del catalogo#####/////
  const infoCatalogo = (idtimbre, idplanilla, status, valorUTE) => {
    onhideCatalogo();
    seleccionarRegistro(idtimbre);
  };
  /////#####$$$$$#####/////

  /////#####funcion para seleccionar el agente del catalogo#####/////
  const seleccionarAgente = (idage, nombage, status, direcc, nre, nli) => {
    showCatalogo();
    if (status === "52") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Expendedor no se encuentra Activo.",
        icono: "informacion",
      });
    } else {
      switch (tipoU) {
        case "G":
          setValues({ ...values, usuariogenerado: idage });
          break;
        case "A":
          setValues({ ...values, usuarioasignado: idage });
          break;
        case "H":
          setValues({ ...values, usuariohabilitado: idage });
          break;
        case "I":
          setValues({ ...values, usuarioinhabilitado: idage });
          break;
        case "D":
          setValues({ ...values, usuariodesincorporado: idage });
          break;
        case "E":
          setValues({ ...values, idexpendio: idage });
          break;

        default:
          break;
      }
    }
  };
  /////#####$$$$$#####/////

  /////#####proceso para actualizar el timbre#####/////
  const procesarRegistro = (body) => {
    setActivate(true);
    let endpoint = "";
    endpoint = `${op.conexion}/api/timbres/modificartimbre`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.respuesta > 0) {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: `${response.data.respuesta} Timbre Modificado Correctamente.`,
              icono: "informacion",
            });
            blanquear();
            txtvalorut_asignacion.current.value = "";
            txtvalorut_venta.current.value = "";
          }
          setActivate(false);
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };
  /////#####$$$$$#####/////

  /////#####actualizar timbres#####/////
  const actualizarTimbre = () => {
    const lista = [];

    lista.push({
      idtimbredetalle: txtIdTimbre.current.value,
      idplanillatimbre: txtIdPlanilla.current.value,
      idexpendio: txtidexpendio.current.value,
      fechaasignado: values.fechaasignado,
      estatustimbre: txtestatustimbre.current.value,
      usuariohabilitado: txtusuariohabilitado.current.value,
      usuarioinhabilitado: txtusuarioinhabilitado.current.value,
      motivodesincorporacion: txtmotivodesincorporacion.current.value,
      fechadesincorporado: values.fechadesincorporado,
      ut: parseFloat(
        txtut.current.value.trim().replace(/\./g, "").replace(",", ".")
      ),
      fechahabilitado: values.fechahabilitado,
      fechainhabilitado: values.fechainhabilitado,
      fechagenerado: values.fechagenerado,
      valorut_asignacion: parseFloat(
        txtvalorut_asignacion.current.value
          .trim()
          .replace(/\./g, "")
          .replace(",", ".")
      ),
      valorut_venta: parseFloat(
        txtvalorut_venta.current.value
          .trim()
          .replace(/\./g, "")
          .replace(",", ".")
      ),
      enterado: txtenterado.current.checked,
      fecha_enterado: values.fecha_enterado,
      idfactura: txtidfactura.current.value,
      usuariodesincorporado: txtusuariodesincorporado.current.value,
      usuariogenerado: txtusuariogenerado.current.value,
      usuarioasignado: txtusuarioasignado.current.value,
    });

    let body = {
      timbre: lista,
    };

    procesarRegistro(body);
  };
  /////#####$$$$$#####/////

  useEffect(() => {
    seleccionarvalorpetro();
  }, []);

  return (
    <div className="container-fluid px-3 py-3">
      <section className="row ">
        <div className="col-md-12 mx-auto h-70 py-5 w-100">
          <div className="col-md-12 rounded">
            <div className="card-body  h-90">
              <div className="row">
                <div
                  className="col-md-12 rounded rounded-8 row py-5 p-4"
                  style={{
                    backgroundColor: "#F9FAFB",
                    boxShadow: "0px 0px 10px 1px #aaaaaa",
                  }}
                >
                  <Dimmer active={activate} />
                  <p className="h5 text-center">
                    <strong>Actualizacion de Timbre Fiscal</strong>
                  </p>
                  <div className="mx-auto px-2">
                    <hr className="dropdown-divider" />
                  </div>
                  <div className="col-md-12 row d-flex justify-content-center">
                    {/* bloque1 */}
                    <div className="input-group input-group-sm py-2 col-md-3">
                      <span
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Codigo:
                      </span>
                      <input
                        type="text"
                        ref={txtIdTimbre}
                        value={
                          values.idtimbredetalle !== null
                            ? values.idtimbredetalle
                            : ""
                        }
                        name="idtimbredetalle"
                        className="form-control"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        onChange={onChange}
                        onKeyUp={validarTimbre}
                        onBlur={validarTimbre}
                      />
                      <button
                        type="button"
                        onClick={onhideCatalogo}
                        className="btn btn-sm btn-success"
                      >
                        <i className="fas fa-search"></i>
                      </button>
                    </div>
                    <div className="input-group input-group-sm py-2 col-md-3">
                      <span
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        N° planilla:
                      </span>
                      <input
                        type="text"
                        ref={txtIdPlanilla}
                        disabled
                        value={
                          values.idplanillatimbre !== null
                            ? values.idplanillatimbre
                            : ""
                        }
                        name="idplanillatimbre"
                        onChange={onChange}
                        className="form-control"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>
                    <div className="input-group input-group-sm py-2 col-md-3">
                      <span
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Valor UTE:
                      </span>
                      <input
                        type="text"
                        ref={txtut}
                        disabled
                        value={
                          values.ut === null
                            ? ""
                            : formatMoneda(
                                values.ut
                                  .toString()
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )
                        }
                        name="ut"
                        className="form-control"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>
                    <div className="input-group input-group-sm py-2 col-md-3">
                      <label className={texto} id="inputGroup-sizing-sm">
                        Status:
                      </label>
                      <select
                        className={border}
                        ref={txtestatustimbre}
                        name="estatustimbre"
                        value={
                          values.estatustimbre !== null
                            ? values.estatustimbre
                            : ""
                        }
                        onChange={onChange}
                        aria-label="Default select example"
                      >
                        <option value="">Status</option>
                        <option value="0">Generado</option>
                        <option value="1">Asignado</option>
                        <option value="2">Habilitado</option>
                        <option value="3">Inhabilitado</option>
                        <option value="4">Desincorporado</option>
                      </select>
                    </div>
                    {/* bloque 1 */}

                    {/* bloque 3 */}
                    <div className="input-group input-group-sm py-2 col-md-3">
                      <span
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Usuario Habilitador:
                      </span>
                      <input
                        type="text"
                        ref={txtusuariohabilitado}
                        value={
                          values.usuariohabilitado !== null
                            ? values.usuariohabilitado
                            : ""
                        }
                        onChange={onChange}
                        name="usuariohabilitado"
                        className="form-control"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                      <button
                        type="button"
                        onClick={seleccionarUsuario(4, "H")}
                        className="btn btn-sm btn-success"
                      >
                        <i className="fas fa-search"></i>
                      </button>
                    </div>

                    <div className="input-group input-group-sm py-2 col-md-3">
                      <span
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Fecha Habilitado:
                      </span>
                      <input
                        type="date"
                        ref={txtfechahabilitado}
                        value={
                          values.fechahabilitado !== null
                            ? moment(values.fechahabilitado).format(
                                "YYYY-MM-DD"
                              )
                            : ""
                        }
                        name="fechahabilitado"
                        onChange={onChange}
                        className="form-control"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>

                    <div className="input-group input-group-sm py-2 col-md-3">
                      <span
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Usuario Inhabilitador:
                      </span>
                      <input
                        type="text"
                        ref={txtusuarioinhabilitado}
                        value={
                          values.usuarioinhabilitado !== null
                            ? values.usuarioinhabilitado
                            : ""
                        }
                        name="usuarioinhabilitado"
                        onChange={onChange}
                        className="form-control"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                      <button
                        type="button"
                        onClick={seleccionarUsuario(3, "I")}
                        className="btn btn-sm btn-success"
                      >
                        <i className="fas fa-search"></i>
                      </button>
                    </div>

                    <div className="input-group input-group-sm py-2 col-md-3">
                      <span
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Fecha Inhabilitado:
                      </span>
                      <input
                        type="date"
                        ref={txtfechainhabilitado}
                        value={
                          values.fechainhabilitado !== null
                            ? moment(values.fechainhabilitado).format(
                                "YYYY-MM-DD"
                              )
                            : ""
                        }
                        name="fechainhabilitado"
                        onChange={onChange}
                        className="form-control"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>
                    {/* bloque 3 */}

                    {/* bloque 4 */}
                    <div className="input-group input-group-sm py-2 col-md-4">
                      <span
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Usuario Desincorporador:
                      </span>
                      <input
                        type="text"
                        ref={txtusuariodesincorporado}
                        value={
                          values.usuariodesincorporado !== null
                            ? values.usuariodesincorporado
                            : ""
                        }
                        name="usuariodesincorporado"
                        onChange={onChange}
                        className="form-control"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                      <button
                        type="button"
                        onClick={seleccionarUsuario(1, "D")}
                        className="btn btn-sm btn-success"
                      >
                        <i className="fas fa-search"></i>
                      </button>
                    </div>

                    <div className="input-group input-group-sm py-2 col-md-4">
                      <span
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Fecha Desincorporacion:
                      </span>
                      <input
                        type="date"
                        ref={txtfechadesincorporado}
                        value={
                          values.fechadesincorporado !== null
                            ? moment(values.fechadesincorporado).format(
                                "YYYY-MM-DD"
                              )
                            : ""
                        }
                        name="fechadesincorporado"
                        onChange={onChange}
                        className="form-control"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>

                    <div className="input-group input-group-sm py-2 col-md-4">
                      <span
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Motivo Desincorporacion:
                      </span>
                      <input
                        type="text"
                        ref={txtmotivodesincorporacion}
                        value={
                          values.motivodesincorporacion !== null
                            ? values.motivodesincorporacion
                            : ""
                        }
                        name="motivodesincorporacion"
                        onChange={onChange}
                        className="form-control"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>
                    {/* bloque 4 */}

                    {/* bloque 5 */}
                    <div className="input-group input-group-sm py-2 col-md-4">
                      <span
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Valor Venta:
                      </span>
                      <input
                        type="text"
                        ref={txtvalorut_venta}
                        disabled
                        value={
                          values.valorut_venta === null
                            ? ""
                            : formatMoneda(
                                values.valorut_venta
                                  .toString()
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )
                        }
                        name="valorut_venta"
                        onKeyUp={handleInputMontoChange}
                        onBlur={handleInputMontoChange}
                        className="form-control"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>
                    {/* bloque 5 */}

                    {/* bloque 6 */}
                    <div className="input-group input-group-sm form-switch py-2 col-md-4 row">
                      <div className="col-4">
                        <label className="form-check-label" htmlFor="enterado">
                          Enterado:
                        </label>
                      </div>
                      <div className="col-6">
                        <input
                          className="form-check-input"
                          ref={txtenterado}
                          checked={
                            values.enterado === null ? false : values.enterado
                          }
                          onChange={onChange}
                          name="enterado"
                          type="checkbox"
                          role="switch"
                          id="enterado"
                        />
                      </div>
                    </div>
                    <div
                      className="input-group input-group-sm py-2 col-md-4"
                      style={{ visibility: visibleEnterado }}
                    >
                      <span
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Fecha Enterado:
                      </span>
                      <input
                        type="date"
                        ref={txtfecha_enterado}
                        value={
                          values.fecha_enterado !== null
                            ? moment(values.fecha_enterado).format("YYYY-MM-DD")
                            : ""
                        }
                        name="fecha_enterado"
                        onChange={onChange}
                        className="form-control"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>
                    <div
                      className="input-group input-group-sm py-2 col-md-4"
                      style={{ visibility: visibleEnterado }}
                    >
                      <span
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Codigo Factura:
                      </span>
                      <input
                        type="text"
                        ref={txtidfactura}
                        value={
                          values.idfactura !== null ? values.idfactura : ""
                        }
                        onChange={onChange}
                        name="idfactura"
                        className="form-control"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>
                    {/* bloque 6 */}
                  </div>
                  <div className="mx-auto px-2">
                    <hr className="dropdown-divider" />
                  </div>
                  <div className=" mt-1 row me-1 col-sm-12 d-flex justify-content-between">
                    <div className="card-footer d-flex justify-content-center mx-1 my-3 row">
                      <button
                        type="button"
                        /* disabled={modificar} */ onClick={() =>
                          setMostrarCambio(true)
                        }
                        className="col-3 mx-auto btn btn-info btn-sm"
                      >
                        Modificar
                      </button>
                      <button
                        type="button"
                        onClick={actualizarTimbre}
                        disabled={inhabilitado}
                        className="col-3 mx-auto btn btn-primary btn-sm"
                      >
                        Guardar
                      </button>
                      <button
                        type="button"
                        disabled={inhabilitado}
                        onClick={cancelar}
                        className="col-3 mx-auto btn btn-warning btn-sm"
                      >
                        Cancelar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <CambioTimbre
        show={mostrarcambio}
        onHideCancela={() => setMostrarCambio(false)}
      />
      <CatalogoTimbres
        show={mostrar}
        onHideCancelaCat={onhideCatalogo}
        infoCatalogo={infoCatalogo}
      />
      <CatalogoAgenteTipo
        show={mostrarAgenteTipo}
        tipo={tipo}
        onHideAceptaCatAge={seleccionarAgente}
        onHideCancelaCatAge={showCatalogo}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
    </div>
  );
}
export default AnularTimbres;

/////////////#####$$$$$#####/////////////////
/////#####Anulacion de Timbres#####/////////
/////#####Programador: Cesar Ratia#####/////
/////#####Empresa: Sygre.ca#####///////////
///////////#####$$$$$#####////////////////



// WEBPACK FOOTER //
// ./src/components/timbres/anularTimbres.js